import { useCallback } from "react";

import { useManageMyGivingPage } from "Giving/ManageMyGivingPage/ManageMyGivingPageContext";

import Fetch from "./API/fetch";

export function useFetchLandingPageData() {
  const { setState } = useManageMyGivingPage();

  return useCallback(
    ({ hideLoading = false } = {}) => {
      if (!hideLoading) {
        setState({ landingPageFetchStatus: "loading" });
      }

      Fetch.getLandingPageData()
        .get()
        .then((res) => {
          setState(res);
          setState({ landingPageFetchStatus: "success" });
        })
        .catch(() => {
          window.location = "https://flocknote.com/need-help-404/";
        });
    },
    [setState]
  );
}
